import { Card, Col, Row } from "antd"
import ReceiptsFilter from "./ReceiptsFilter"
import ReceiptsTable from "./ReceiptsTable"

const Receipts = () => {

    return (<>
        <Card>
            <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                <Col span={24}>
                    <ReceiptsFilter />
                </Col>
                <Col span={24}>
                    <ReceiptsTable />
                </Col>
            </Row>
        </Card>
    </>)
}
export default Receipts
